export enum GeneralActionTypes {
  GET_META_DATA = 'GET_META_DATA',
  GET_USER_HIERARCHY = 'GET_USER_HIERARCHY',
  GET_ETL_DATA = 'GET_ETL_DATA',
  SET_SHOW_SESSION_MODAL = 'SET_SHOW_SESSION_MODAL',
  GET_USER_PREFERENCES = 'GET_USER_PREFERENCES',
  SET_USER_PREFERENCES = 'SET_USER_PREFERENCES',
  GET_CLIENT_NAME_RESOLUTION_MAP = 'GET_CLIENT_NAME_RESOLUTION_MAP',
  GET_CONTAINER_NAME_RESOLUTION_MAP = 'GET_CONTAINER_NAME_RESOLUTION_MAP',
  GET_COLLECTION_NAME_RESOLUTION_MAP = 'GET_COLLECTION_NAME_RESOLUTION_MAP',
  GET_LEAD_DATA_RESOLUTION_MAP = 'GET_LEAD_DATA_RESOLUTION_MAP',
  GET_BANKER_NAME_RESOLUTION_MAP = 'GET_BANKER_NAME_RESOLUTION_MAP',
  RESET_COLLECTION_CONTAINER_NAME_RESOLUTION = 'RESET_COLLECTION_CONTAINER_NAME_RESOLUTION',
}
